import { OTHERWORLD_BACKDROPS } from '../../../game/effects/atmosphere/silhouettes/otherworldBackdrops';
import { darkBiome } from '../biomeArchetypes';
import { Z_LAYERS } from '../../../game/rendering/Z_LAYERS';

/** Void-serpent — a dark abyssal realm where vast serpent skeletons coil through
 *  the darkness. Proves the serpentSkeleton shape + leviathans kind work over a
 *  dark/abyss palette. The serpents are near-black with a cold cyan edge-highlight
 *  rim — barely visible, more felt than seen. */
export const VOID_SERPENT = darkBiome({
  id: 'void_serpent',
  sky: { from: 0x0a0a1a, to: 0x121228 },
  motes: { colors: [0x1a3a5a, 0x0a2a4a], count: 14, sizeMin: 3, sizeMax: 8, driftPx: 18, periodMinMs: 10000, periodMaxMs: 20000, alphaMin: 0.2, alphaMax: 0.5 },
  rays: { color: 0x0a2a4a },
  glow: {
    blobs: [
      { color: 0x0a2a4a, atX: 0.5, atY: 0.4, size: 500, alpha: 0.06 },
      { color: 0x1a3a5a, atX: 0.2, atY: 0.6, size: 350, alpha: 0.05 },
    ],
    breathe: { periodMs: 9000, min: 0.6, max: 1.4 },
  },
  lightField: { palette: [0x0a2a4a, 0x1a3a5a], count: 8, sizeMin: 100, sizeMax: 250, alphaMin: 0.03, alphaMax: 0.10, driftRadius: 50, periodMinMs: 12000, periodMaxMs: 24000 },
  weather: { mode: 'fall', color: 0x0a1a2a,
    size: 4, frequencyMs: 300, lifespanMs: 8000, speed: 10, gravityY: 5, windX: 2, alphaEnd: 0.3,
    gust: { periodMs: 6000, min: 0.3, max: 0.8 } },
  flicker: { color: 0x1a3a5a, size: 200, baseAlpha: 0.04, flickerAmp: 0.03, hzMin: 0.3, hzMax: 1.5, anchors: [{ atX: 0.5, atY: 0.4 }, { atX: 0.2, atY: 0.6 }] },
  extraAtmosphereLayers: [
    // The void-serpents: serpentSkeleton silhouettes coiling through the abyss.
    // Near-black with a cold cyan rim — barely visible, more felt than seen.
    {
      kind: 'leviathans',
      shape: 'serpentSkeleton',
      planes: [
        { count: 1, widthMin: 700, widthMax: 1000, speedMin: 4, speedMax: 8, alpha: 0.14, tint: 0x0a1a2a, depth: Z_LAYERS.LEVIATHAN_FAR },
        { count: 1, widthMin: 1000, widthMax: 1500, speedMin: 2, speedMax: 5, alpha: 0.18, tint: 0x0a2a4a, depth: Z_LAYERS.LEVIATHAN_NEAR },
      ],
      bob: { ampPx: 30, periodMinMs: 12000, periodMaxMs: 24000 },
      edgeHighlight: true,
      edgeColor: 0x2a8aaa,
      detail: 1,
      direction: 'both',
      bandYMin: 0.1,
      bandYMax: 0.6,
    },
  ],
  parallax: [
    { svg: OTHERWORLD_BACKDROPS.abyss.far, shape: 'spires', color: 0x101020, speed: 0.01, height: 600, alpha: 0.65, detail: 0.5 },
    { svg: OTHERWORLD_BACKDROPS.abyss.mid, shape: 'spires', color: 0x141428, speed: 0.03, height: 400, alpha: 0.55, detail: 0.7 },
    { svg: OTHERWORLD_BACKDROPS.abyss.near, shape: 'spires', color: 0x181830, speed: 0.08, height: 250, alpha: 0.45, detail: 1.0 },
  ],
  fog: { color: 0x0a0a1a, bands: 4, alphaMin: 0.08, alphaMax: 0.20, driftPx: 30, periodMinMs: 12000, periodMaxMs: 24000 },
  closer: { vignette: { color: 0x000005, edgeAlpha: 0.40 }, grade: { top: 0x0a0a1a, bottom: 0x050510, strength: 0.12, blend: 'normal' } },
});
